import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import LoadingScreen from '@/components/feature/LoadingScreen';

export default function ProtectedRoute() {
  const { session, profile, loading, profileLoading } = useAuth();

  if (loading) return <LoadingScreen />;
  if (!session) return <Navigate to="/login" replace />;
  if (profileLoading) return <LoadingScreen />;
  if (!profile || profile.status !== 'approved') return <Navigate to="/pending" replace />;

  return <Outlet />;
}